import ICMAxios from "../ICMAxios";

const getInventoryCompletionDataAsync = async (inventoryId: any) => {
    const response = await ICMAxios.get(`v1/Inventory/${inventoryId}/completiondata`);
    return response.data;
}

const getUserStatusAsync = async (inventoryId: any,formData: any) => {
    const response = await ICMAxios.post(`v1/Inventory/${inventoryId}/userstatus`, formData);
    return response.data;
}

const getInventoryMasterStatusAsync = async () => {
    const response = await ICMAxios.get(`v1/Inventory/masterstatus`);
    return response.data;
}

const dashboardService = { getInventoryCompletionDataAsync, getUserStatusAsync, getInventoryMasterStatusAsync }
export default dashboardService;